export const EXPANDED_SIZE = '200px';
export const COLLAPSED_SIZE = '64px';
export const CLOSED_SIZE = '0px';
